import React, { useState, useEffect } from 'react';

const TypingBackground1 = () => {
  const codeLines = React.useMemo(() => [
    `import java.util.Random;`,
    `public class RandomCode {`,
    `    public static void main(String[] args) {`,
    `        Random rand = new Random();`,
    `        for (int i = 0; i < 10; i++) {`,
    `           int index = rand.nextInt(characters.length());`,
    `           randomString.append(characters.charAt(index));`,
    `        }`,
    `        System.out.println("Random string: " + randomString.toString());`,
    `    }`,
    `}`
  ], []);

const [displayedLines, setDisplayedLines] = useState([]);
  const [lineIndex, setLineIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    let timeout;

    if (!isDeleting && lineIndex === codeLines.length) {
      timeout = setTimeout(() => {
        setIsDeleting(true);
        setLineIndex(lineIndex - 1);
        setCharIndex(codeLines[lineIndex - 1].length);
      }, 1500);
      return () => clearTimeout(timeout);
    }

    if (isDeleting && lineIndex < 0) {
      timeout = setTimeout(() => {
        setIsDeleting(false);
        setLineIndex(0);
        setCharIndex(0);
        setDisplayedLines([]);
      }, 1000);
      return () => clearTimeout(timeout);
    }

    if (!isDeleting) {
      const currentLine = codeLines[lineIndex] || '';
      if (charIndex <= currentLine.length) {
        timeout = setTimeout(() => {
          const updatedLines = [...displayedLines];
          updatedLines[lineIndex] = currentLine.slice(0, charIndex);
          setDisplayedLines(updatedLines);
          setCharIndex(charIndex + 1);
        }, 40);
      } else {
        timeout = setTimeout(() => {
          setLineIndex(lineIndex + 1);
          setCharIndex(0);
        }, 300);
      }
    } else {
      const currentLine = displayedLines[lineIndex] || '';
      if (charIndex >= 0) {
        timeout = setTimeout(() => {
          const updatedLines = [...displayedLines];
          updatedLines[lineIndex] = currentLine.slice(0, charIndex);
          setDisplayedLines(updatedLines);
          setCharIndex(charIndex - 1);
        }, 30);
      } else {
        timeout = setTimeout(() => {
          setLineIndex(lineIndex - 1);
          setCharIndex(displayedLines[lineIndex - 1]?.length || 0);
        }, 200);
      }
    }

    return () => clearTimeout(timeout);
  }, [charIndex, lineIndex, isDeleting, displayedLines, codeLines]);

  return (
    <div style={{ whiteSpace: 'pre' }} className="fixed top-[70%] left-[40%] z-0 max-w-2xl pointer-events-none font-mono">
      <div className="text-left text-sm md:text-xl font-bold text-blue-400 opacity-30 drop-shadow-[0_0_12px_rgba(59,130,246,0.7)] select-none leading-relaxed">
        {displayedLines.map((line, idx) => (
          <div key={idx}>
            {line}
            {idx === lineIndex && <span className="animate-blink">_</span>}
          </div>
        ))}
      </div>

      <style>
        {`
          @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0; }
          }
          .animate-blink {
            animation: blink 1s step-start infinite;
          }
        `}
      </style>
    </div>
  );
};

export default TypingBackground1;
